import { api } from "../../services/api";

export async function fetchChart() {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.get("/chart", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
